import React from "react";

const Hero = () => {
  return (
    <section
      id="home"
      className="relative h-screen w-full flex items-center overflow-hidden"
    >
      {/* Main Content Layout constrained to 60% on desktop */}
      <div className="layout-container w-full">
        {/* Left vertical guideline creates structural blueprint columns */}
        <div className="border-l border-borderSubtle pl-6 md:pl-10 flex flex-col gap-8 max-w-2xl py-4">
          {/* Accent Status Tag */}
          <div className="flex items-center gap-2 text-xs font-mono tracking-widest text-accent uppercase animate-entrance">
            <span className="w-1.5 h-1.5 rounded-full bg-accent"></span>
            SYSTEM_STATUS // ONLINE
          </div>

          {/* Name & Blinking Cursor */}
          <div>
            <h1 className="text-5xl md:text-6xl font-normal tracking-tight text-white cursor-blink animate-entrance">
              Rupak Boral
            </h1>
          </div>

          {/* Role & One-liner Description */}
          <div className="flex flex-col gap-4 animate-entrance delay-150">
            <p className="text-accent text-lg uppercase tracking-wider font-medium">
              Software Engineer – Integrations
            </p>
            <p className="text-zinc-400 text-lg md:text-xl leading-relaxed font-normal">
              Building AI-powered VoIP integrations and reliable backend systems
              for real-time communication.
            </p>
          </div>

          {/* Action CTAs: Styled with subtle borders for interactive boundaries */}
          <div className="flex items-center gap-4 mt-2 animate-entrance delay-300">
            <a
              href="https://github.com/RupakBoral"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2 border border-borderSubtle hover:border-accent text-sm tracking-wide font-normal transition-colors duration-300"
            >
              GitHub &rarr;
            </a>
            <a
              href="https://drive.google.com/file/d/1i2ArSzQXebaUFGHcUL5tJOd-KU-pEV84/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="px-5 py-2 border border-borderSubtle hover:border-accent text-sm tracking-wide font-normal transition-colors duration-300"
            >
              Resume &rarr;
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
